
import Vue from 'vue'
import { EntityService } from '@/services/entity.service'
import { validationMixin } from 'vuelidate'
import { required, maxLength } from 'vuelidate/lib/validators'

const entityService = new EntityService()

export default Vue.extend({
  name: 'ProjectsEdit',
  mixins: [validationMixin],
  validations: {
    form: {
      code: {
        required,
        maxLength: maxLength(150)
      },
      name: { required }
    }
  },
  props: ['value', 'editEntity'],
  data: () => ({
    entity: 'projects',
    isLoading: false,
    search: '',
    form: {
      code: '',
      name: '',
      keywords: []
    }
  }),
  async created () {
    this.form = {
      code: this.editEntity.code,
      name: this.editEntity.name,
      keywords: this.editEntity.keywords
    }
  },
  methods: {
    toggleModal (value: boolean) {
      this.$emit('input', value)
    },
    async save () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.isLoading = true
        await entityService.updateEntity(this.editEntity.id, this.entity, this.form)
        this.isLoading = false
        this.$emit('input', false)
      }
    },
    getError: function (element: string) {
      const obj = this.$v.form[element] || { $error: '' }
      if (obj.$error) return 'Campo inválido'
    }
  }
})
